import style from "./page-loader.scss";

const PageLoader = () => {
    return (
        <div className={style.pageLoader}>
            <div className={style.spinner} />
            <div className={style.shimmerCard}>
                <div className={style.shimmerLine} />
                <div className={style.shimmerLine} />
                <div className={style.shimmerLine} />
                <div className={style.shimmerLine} />
                <div className={style.shimmerLine} />
            </div>
        </div>
    );
};

export default PageLoader;
